import React from 'react';

const NoRadioIcon = () => (
  <svg viewBox="0 0 30 30">
    <title>{'Atom / Icon / Navigation / No_radio'}</title>
    <path
      d="M3.854 3.146l23 23a.502.502 0 01-.708.708l-23-23a.502.502 0 01.708-.708zM6.879 9l1 1h-2.88v13h15.88l1 1H4.999a1 1 0 01-1-1V10a1 1 0 011-1h1.88zM25 9a1 1 0 011 1v13a.984.984 0 01-.244.635L25 22.879V10H12.121l-1-1zm-14.5 4c.145 0 .282.025.421.043l3.037 3.035c.017.141.042.277.042.422 0 1.93-1.57 3.5-3.5 3.5S7 18.43 7 16.5 8.57 13 10.5 13zm0 1A2.503 2.503 0 008 16.5c0 1.379 1.122 2.5 2.5 2.5s2.5-1.121 2.5-2.5-1.122-2.5-2.5-2.5zm12 4a.5.5 0 010 1h-1.379l-1-1zm0-2a.5.5 0 010 1h-3.379l-1-1zm0-2a.5.5 0 010 1h-5.379l-.902-.902A.485.485 0 0116.5 14zm0-8c.827 0 1.5.673 1.5 1.5V8h-1v-.5a.5.5 0 00-.5-.5H9.121l-1-1z"
      fill="#8D929E"
      fillRule="nonzero"
    />
  </svg>
);

export default NoRadioIcon;
